<template>
  <div id="visitObject">
    <el-dialog
      :visible.sync="showDialogVisible"
      :close-on-click-modal="false"
      width="240px"
      height="300px"
    >
      <el-form inline size="small">
        <!--生成二维码-->
        <template>
          <div id="qrcodes">
            <vue-qr
              ref="QRCode"
              class="qrcode"
              :text="text"
              :size="200"
            />
          </div>
        </template>
      </el-form>
      <div slot="footer">
        <el-button @click="showDialogVisible = false">
          取 消
        </el-button>
        <el-button type="success" @click="downloadQRCode()">
          下载二维码
        </el-button>
      </div>
    </el-dialog>

    <el-form inline size="small">
      <el-form-item label="医院名称">
        <el-input v-model="searchForm.hospitalName" placeholder="请输入医院名称" clearable />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">
          查 询
        </el-button>
      </el-form-item>
    </el-form>

    <el-table
      id="xls-table"
      ref="visitObjectTableRef"
      :data="visitObjectPage.list"
      row-key="bid"
      default-expand-all
      :cell-style="{padding: '6px'}"
      :header-cell-style="{background: '#f8f8f9'}"
      :height="getTableHeight()"
      @row-click="handleRowClick"
    >
      <el-table-column prop="hospitalName" label="医院名称" />
      <el-table-column prop="name" label="部门名称" />
      <el-table-column prop="realName" label="姓名" />
      <el-table-column prop="professionalName" label="职称" />
      <el-table-column prop="sex" label="性别">
        <template slot-scope="scope">
          <span v-if="scope.row.sex===1">男</span>
          <span v-if="scope.row.sex===0">女</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            icon="el-icon-s-grid"
            size="small"
            @click.stop="getTokenQRCode(scope.$index, scope.row)"
          >
            二维码
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :total="visitObjectPage.total"
      :current-page="searchForm.pageNum"
      :page-size="searchForm.pageSize"
      :page-sizes="[10, 15, 20]"
      layout="total, sizes, prev, pager, next, jumper"
      background
      @current-change="pageNumChange"
      @size-change="pageSizeChange"
    />
  </div>
</template>

<script>
import {
  getWebListByCondition,
  selectInfoById
} from '@/api/system/dept'
import VueQr from 'vue-qr'
export default {
  name: 'QRCode',
  components: {
    VueQr
  },
  data () {
    return {
      showDialogVisible: false,
      text: '',
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        hospitalName: '',
        name: '',
        realName: '',
        sex: '',
        professionalName: ''
      },
      visitObjectPage: {
        total: 0,
        list: []
      }
    }
  },
  mounteds () {
  },
  created () {
    this.getList()
  },
  methods: {
    getTokenQRCode (index, row) {
      selectInfoById(row.bid).then(res=> {
        let str = 'https://sxrmyy-visitor-web.zpsoftware.cn/api/?id=' + res.bid + '&sex=' + res.sex + '&hospitalName=' + res.hospitalName + '&name=' + res.name + '&realName=' + res.realName
        console.log(str)
        this.text = str
        this.searchForm.hospitalName = res.hospitalName
        this.searchForm.name = res.name
        this.searchForm.realName = res.realName
        this.showDialogVisible = true
      })
    },
    // 下载二维码图片
    downloadQRCode () {
      var oQrcode = document.querySelector('#qrcodes img')
      var url = oQrcode.src
      var a = document.createElement('a')
      var event = new MouseEvent('click')
      // 下载图名字
      a.download = this.searchForm.hospitalName + '-' + this.searchForm.name + '-' + this.searchForm.realName + '的二维码'
      //url
      a.href = url
      //合成函数，执行下载
      a.dispatchEvent(event)
      this.showDialogVisible = false
    },
    getList () {
      getWebListByCondition(this.searchForm).then(res=>{
        this.visitObjectPage = res
      })
    },
    handleRowClick (row, col, event) {
      this.$refs.visitObjectTableRef.toggleRowExpansion(row)
    },
    handleSearch () {
      getWebListByCondition(this.searchForm).then(res=>{
        this.visitObjectPage = res
      })
    },
    pageNumChange (pageNum) {
      this.searchForm.pageNum = pageNum
      getWebListByCondition(this.searchForm).then(res => {
        this.visitObjectPage = res
      })
    },
    pageSizeChange (pageSize) {
      this.searchForm.pageSize = pageSize
      this.searchForm.pageNum = 1
      getWebListByCondition(this.searchForm).then(res => {
        this.visitObjectPage = res
      })
    }
  }
}
</script>

<style scoped>
    #visitObject .qrcode{
        position: relative;
        left: 20px;
    }
</style>
